<template>
  <div class="loader">
    <font-awesome-icon icon="spinner" pulse />
  </div>
</template>

<script>
export default {
  name: 'Spinner'
};
</script>

<style lang="scss">
.loader {
  width: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 36px;
    color: #ef0c71;
  }
}
</style>

